// extracted by mini-css-extract-plugin
export default {"root":"style_root__zMbKQ","icon":"style_icon__xpZNN","label":"style_label__24bX+","error":"style_error__RkUWM"};